import { useAtom, useAtomValue } from 'jotai';
import getConfig from 'next/config';
import { Box } from 'components/primitives/box';
import Counter from 'components/ui/Counter/Counter';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Text } from 'components/primitives/typography';
import { passengersCountTempAtom, passengersCountAtom, passengersFilterActiveAtom } from '../filterStore';

const { COVID_LIMIT_ENABLED } = getConfig().publicRuntimeConfig;

export default function PassengersFilterContent({ isDropdown = false, ...props }) {
  const [passengers, setPassengers] = useAtom(passengersCountAtom);
  const [tempPassengers, setTempPassengers] = useAtom(passengersCountTempAtom);
  const currentPassengers = isDropdown ? passengers : tempPassengers;
  const setBoth = (val) => {
    setPassengers(val);
    setTempPassengers(val);
  };
  const passengerSetter = isDropdown ? setBoth : setTempPassengers;
  const timeoutRef = useRef(null);
  const rudderTrack = useRudderStackTrack();

  // keeping the display value up to date if passengers are updated in the bar but not dropdown
  useEffect(() => {
    if (passengers !== tempPassengers) {
      setTempPassengers(passengers);
    }
  }, []);
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      rudderTrack('passengers_change_search', {
        value: currentPassengers,
      });
    }, 2000);
  }, [currentPassengers]);

  return (
    <PassengersWrapper>
      <Text fWeight="600" fSize="16px">
        Passengers
      </Text>
      <Box {...props} height="32px" data-testid="search-filter-passengers-box">
        <Counter
          boatCapacity={COVID_LIMIT_ENABLED ? 10 : 14}
          minimum={1}
          value={currentPassengers}
          // buttonSize={40}
          onClick={passengerSetter}
        />
      </Box>
    </PassengersWrapper>
  );
}

export const PassengersLabel = () => {
  const passengers = useAtomValue(passengersCountAtom);
  const filterActive = useAtomValue(passengersFilterActiveAtom);
  if (!filterActive) return <span>Passengers</span>;
  return <span>{`${passengers}${passengers === 14 ? '+' : ''} ${passengers === 1 ? 'Passenger' : 'Passengers'}`}</span>;
};

const PassengersWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
